import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaUser,
  FaDollarSign,
  FaHistory,
  FaHome,
} from "react-icons/fa";
import { MdCurrencyExchange } from "react-icons/md";
import { GoGraph } from "react-icons/go";
import "../../styles/pay.css";
import { Tooltip } from "bootstrap";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);

  const menuItems = [
    { icon: <FaHome size={25} />, path: "/dashboard", title: "Home" },
    { icon: <GoGraph size={25} />, path: "/tradingwidget", title: "Graph" },
    { icon: <FaHistory size={25} />, path: "/history", title: "History" },
    { icon: <FaDollarSign size={25} />, path: "/bank", title: "Funds" },
    { icon: <FaUser size={25} />, path: "/profile", title: "Profile" },
    {
      icon: <MdCurrencyExchange size={25} />,
      // onClick: () =>
      //   window.open("https://currex.richesse.solutions/dashboard", "_blank"),
      // isExternal: true,
      title: "Currency Exchange",
    },
  ];

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(
      (tooltipTriggerEl) =>
        new Tooltip(tooltipTriggerEl, {
          placement: "right",
          delay: { show: 300, hide: 100 },
        })
    );
    return () => {
      tooltipList.forEach((tooltip) => tooltip.dispose());
    };
  }, []);

  return (
    <Container
      fluid
      className={`vh-100 sidebar-container p-0 d-flex flex-column ${
        collapsed ? "collapsed-sidebar" : "expanded-sidebar"
      }`}
      style={{
        position: "fixed",
        top: 60,
        left: 0,
        width: collapsed ? "70px" : "230px",
        height: "100vh",
        backgroundColor: "black",
        paddingTop: "20px",
        zIndex: 1000,
        transition: "width 0.3s ease",
        gap: "15px",
      }}
      id="sidebar"
      onMouseEnter={() => setCollapsed(false)}
      onMouseLeave={() => setCollapsed(true)}
    >
      {menuItems.map((item, index) => {
        const isActive = location.pathname === item.path;

        return (
          <Row
            key={index}
            className={`sidebar-item align-items-center m-0 px-2 mb-4 ${
              isActive ? "active-sidebar-item" : ""
            }`}
            style={{
              cursor: "pointer",
              padding: "12px 0",
              backgroundColor: isActive ? "#e2c25e20" : "transparent",
              borderLeft: isActive ? "4px solid #e2c25e" : "4px solid transparent",
              transition: "all 0.3s ease",
            }}
            onClick={() => {
              if (item.isExternal && item.onClick) {
                item.onClick();
              } else if (item.path) {
                navigate(item.path);
              }
            }}
          >
            <Col className="d-flex align-items-center">
              <span
                data-bs-toggle="tooltip"
                title={item.title}
                style={{
                  color: isActive ? "#e2c25e" : "#e2c25e",
                  fontSize: "22px",
                  marginRight: collapsed ? "0" : "15px",
                  transition: "margin 0.2s ease",
                }}
              >
                {item.icon}
              </span>
              {!collapsed && (
                <span
                  style={{
                    color: isActive ? "#e2c25e" : "#e2c25e",
                    fontWeight: isActive ? "bold" : "normal",
                    fontSize: "16px",
                  }}
                >
                  {item.title}
                </span>
              )}
            </Col>
          </Row>
        );
      })}
    </Container>
  );
};

export default Sidebar;
